// extracted by mini-css-extract-plugin
export var buttonContainer = "_6i-1";
export var fontSizeSelect = "_6i-3";
export var formatSelect = "_6i-2";
export var formats = "_6i-4";
export var hidden = "_6i-5";
export var icon = "_6i-6";
export var select = "_6i-0";